<div class="certificate-pagination-container">
    <nav aria-label="Certificate navigation" *ngIf="totalCertificate > 1">
        <ul class="pagination justify-content-end">
            <!-- Previous button with improved accessibility -->
            <li class="page-item" [ngClass]="{'disabled': currentCertificateIndex <= 0}">
                <a class="page-link" 
                   (click)="onPrevious()" 
                   [attr.aria-disabled]="currentCertificateIndex <= 0" 
                   tabindex="{{currentCertificateIndex <= 0 ? '-1' : '0'}}" 
                   role="button"
                   aria-label="Previous certificate">
                    <i class="fa fa-chevron-left" aria-hidden="true"></i> <span>Previous</span>
                </a>
            </li>
            
            <!-- Smart Certificate number buttons with ellipses for large sets -->
            <!-- First page -->
            <li class="page-item" *ngIf="totalCertificate > 0" [ngClass]="{'active': 0 === currentCertificateIndex}">
                <a class="page-link" 
                   (click)="onPageSelected(0)" 
                   role="button" 
                   [attr.aria-current]="0 === currentCertificateIndex ? 'page' : null"
                   [attr.aria-label]="'Go to certificate 1'"
                   tabindex="{{0 === currentCertificateIndex ? '-1' : '0'}}">
                    1
                </a>
            </li>
            
            <!-- Left ellipsis -->
            <li class="page-item disabled" *ngIf="currentCertificateIndex > 3">
                <span class="page-link">...</span>
            </li>
            
            <!-- Pages around current -->
            <ng-container *ngFor="let i of getVisibleCertificateIndices()">
                <li class="page-item" [ngClass]="{'active': i === currentCertificateIndex}" *ngIf="i > 0 && i < totalCertificate - 1">
                    <a class="page-link" 
                       (click)="onPageSelected(i)" 
                       role="button" 
                       [attr.aria-current]="i === currentCertificateIndex ? 'page' : null"
                       [attr.aria-label]="'Go to certificate ' + (i + 1)"
                       tabindex="{{i === currentCertificateIndex ? '-1' : '0'}}">
                        {{i + 1}}
                    </a>
                </li>
            </ng-container>
            
            <!-- Right ellipsis -->
            <li class="page-item disabled" *ngIf="currentCertificateIndex < totalCertificate - 4">
                <span class="page-link">...</span>
            </li>
            
            <!-- Last page -->
            <li class="page-item" *ngIf="totalCertificate > 1" [ngClass]="{'active': totalCertificate - 1 === currentCertificateIndex}">
                <a class="page-link" 
                   (click)="onPageSelected(totalCertificate - 1)" 
                   role="button" 
                   [attr.aria-current]="totalCertificate - 1 === currentCertificateIndex ? 'page' : null"
                   [attr.aria-label]="'Go to certificate ' + totalCertificate"
                   tabindex="{{totalCertificate - 1 === currentCertificateIndex ? '-1' : '0'}}">
                    {{totalCertificate}}
                </a>
            </li>
            
            <!-- Next button with improved accessibility -->
            <li class="page-item" [ngClass]="{'disabled': currentCertificateIndex >= totalCertificate - 1}">
                <a class="page-link" 
                   (click)="onNext()" 
                   [attr.aria-disabled]="currentCertificateIndex >= totalCertificate - 1" 
                   tabindex="{{currentCertificateIndex >= totalCertificate - 1 ? '-1' : '0'}}" 
                   role="button"
                   aria-label="Next certificate">
                    <span>Next</span> <i class="fa fa-chevron-right" aria-hidden="true"></i>
                </a>
            </li>
        </ul>
    </nav>
    
    <!-- Certificate counter display -->
    <div class="certificate-counter" *ngIf="totalCertificate > 0">
        <span class="badge badge-pill" [ngClass]="{'badge-primary': true}">
            Certificate {{currentCertificateIndex + 1}} of {{totalCertificate}}
        </span>
    </div>
</div>
